import React from "react";
import PageHero from "@/components/public/PageHero";
import { useSite } from "@/context/SiteContext";
import { Check } from "lucide-react";

const ACCOUNTS = [
  { name: "Standard", key: "demo_register", min: "$250", spread: "from 1.2 pips", lev: "1:200", commission: "Zero", exec: "Market", popular: false },
  { name: "Pro VIP", key: "live_register", min: "$5,000", spread: "from 0.4 pips", lev: "1:400", commission: "Reduced", exec: "Market", popular: true },
  { name: "ECN Institutional", key: "live_register", min: "$25,000", spread: "from 0.0 pips", lev: "1:500", commission: "Raw + fee", exec: "ECN", popular: false },
];
const ROWS = [["Min. Deposit", "min"], ["Spreads", "spread"], ["Leverage", "lev"], ["Commission", "commission"], ["Execution", "exec"]];

export default function Accounts() {
  const { trackAndGo } = useSite();
  return (
    <div>
      <PageHero overline="Accounts" title="Account Types Built Around Your Strategy" subtitle="From first steps to institutional volume — transparent conditions across every tier." image="/images/globe_3d_gold.jpg" />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container">
          <div className="grid md:grid-cols-3 gap-6">
            {ACCOUNTS.map((a) => (
              <div key={a.name} className={`cb-card p-8 relative ${a.popular ? "border-[#D8AE4E]/60" : ""}`} data-testid={`accounts-card-${a.name.toLowerCase().replace(/\s+/g, "-")}`}>
                {a.popular && <span className="absolute -top-3 left-8 btn-gold px-3 py-1 text-xs">Most Popular</span>}
                <h3 className="font-serif text-2xl text-[#0B1D40] mb-1">{a.name}</h3>
                <p className="font-serif text-4xl gold-text my-5">{a.min}</p>
                <dl className="space-y-3 text-sm mb-8">
                  {ROWS.slice(1).map(([label, k]) => (
                    <div key={k} className="flex justify-between border-b border-slate-200 pb-2"><dt className="text-slate-500">{label}</dt><dd className="text-[#0B1D40] font-mono">{a[k]}</dd></div>
                  ))}
                </dl>
                <button onClick={() => trackAndGo(a.key)} className={`w-full py-3 text-sm ${a.popular ? "btn-gold" : "btn-outline-gold"}`} data-testid={`accounts-cta-${a.name.toLowerCase().replace(/\s+/g, "-")}`}>Open {a.name}</button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
